import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/I18nProvider";
import MagneticButton from "../components/MagneticButton";

export default function CtaBand() {
  const { t } = useI18n();
  return (
    <section className="py-28 lg:py-36 bg-[#050505] relative overflow-hidden" data-testid="cta-band">
      <motion.div
        aria-hidden
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2 }}
        className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full bg-rouge/15 blur-[140px]"
      />
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <h3 className="font-serif-editorial text-4xl sm:text-5xl lg:text-7xl text-ink-100 tracking-tight leading-[1.02]">
              {t.cta_band.title}
            </h3>
            <p className="mt-6 text-ink-300 text-base lg:text-lg max-w-xl">{t.cta_band.sub}</p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <MagneticButton
              as={Link}
              to="/contact"
              data-testid="cta-band-button"
              data-cursor={t.cta_band.btn}
              className="group inline-flex items-center gap-3 bg-rouge hover:bg-rouge-deep text-ink-100 px-8 py-5 text-[11px] tracking-[0.24em] uppercase transition-colors"
            >
              {t.cta_band.btn} <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </MagneticButton>
          </div>
        </div>
      </div>
    </section>
  );
}
